import {
    LoggerConfiguration,
    LoggerMode,
    LoggerStatus,
    LoggerType,
    SensorCode,
} from 'app/enums/label.enums'
import {
    Company,
} from 'app/Apps/ContactManagement/Companies/Companies.types'
import {
    WithId,
} from 'app/types/common.types'

type ConfigLoggerOption = {
    value: string,
    label: string
}

export type ConfigLogger = {
    title: string,
    name: string,
    loggerType?: LoggerType,
    sensorCodes?: SensorCode[],
    positions?: string[],
    options: ConfigLoggerOption[]
}

type LoggerTypeDetails = {
    changedOn?: string,
    createdOn?: string,
    dataTypes?: string[],
    deleted?: boolean
    hasMultipleSensors: boolean,
    loggerType?: LoggerType
    positionConfiguration: LoggerConfiguration[],
    priority?: number,
}

type LoggerBase = {
    containerSerialNumber?: string,
    id?: number,
    lastEventDoorOnUtc?: number,
    lastMeasuredOnUtc?: number,
    loggerNumber?: string,
    loggerQrCode?: string,
    loggerStatus?: LoggerStatus,
    loggerType?: LoggerType,
    loggerMode?: LoggerMode,
    hardwareVersion?: string,
    softwareVersion?: string,
}

export type LoggerTable = LoggerBase & {
    gatewayGatewayId?: number,
    gatewayImeiMac?: string,
    locationName?: string,
    batteryVoltage?: string,
    rentingCompany?: Company,
    createdOn?: string,
    loggerMode?: LoggerMode,
    lastActivatedOn: string,
    isTestingLogger?: boolean,
    productionBatchNumber?: string,
}

export type LoggerResponse = LoggerBase & {
    allowedSensorCodes?: SensorCode[],
    calibrationDocuments?: any[],
    changedOn?: string,
    containerId?: number,
    createdBy?: string,
    createdOn?: string,
    deleted?: boolean,
    loggerTypeDetails?: LoggerTypeDetails
    reservedForUsers?: any[],
    batteryVoltage?: string,
    gateway?: {
        id: number,
        locationRemark: string,
        location: WithId<string>,
    },
    location?: WithId<number>,
    destinationLocation?: WithId<number>
    rentingCompany?: Company,
    lastActivatedOn?: string,
    lastCalibratedOn?: string,
    isTestingLogger?: boolean,
    temperatureTransmissionRateSecondsStationary?: number,
    temperatureTransmissionRateSecondsMoving?: number,
    measurementIntervalSeconds?: number,
}

export default LoggerType
